import { PhotoFilter } from '@components/reviews/components/search-sort-filter/review-filter-pills/photo-filter';
import { RatingsFilterPill } from '@components/reviews/components/search-sort-filter/review-filter-pills/ratings-filter';
import React from 'react';
import Styles from './styles.scss';

export const ReviewFilterPills = () => {
	return (
		<div className={Styles.filterPillsContainer}>
			<RatingsFilterPill />
			<PhotoFilter />
		</div>
	);
};
